export default "<div class=\"toggle\" [ngClass]=\"{'selected': selected}\" (click)=\"toggleSelected()\">\n  {{ title }}\n</div>\n"